import { render, staticRenderFns } from "./ExtractionScheme.vue?vue&type=template&id=f9c5db34&scoped=true"
import script from "./ExtractionScheme.vue?vue&type=script&lang=js"
export * from "./ExtractionScheme.vue?vue&type=script&lang=js"
import style0 from "./ExtractionScheme.vue?vue&type=style&index=0&id=f9c5db34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c5db34",
  null
  
)

export default component.exports